<!-- @format -->

<template>
  <div class="home">
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <notifications group="client" position="bottom center" />
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>Clients</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div class="ui secondary pointing menu">
              <a
                class="ui item"
                v-bind:style="
                  orderBy == 'updated_as_at'
                    ? 'border-width: medium;border-color:#000000!important'
                    : ''
                "
                v-bind:class="{ active: orderBy == 'updated_as_at' }"
                @click.prevent="refreshResults('updated_as_at', 'desc')"
              >
                Last Updated</a
              >
              <a
                class="ui item"
                v-bind:style="
                  orderBy == 'full_name'
                    ? 'border-width: medium;border-color:#000000!important'
                    : ''
                "
                v-bind:class="{ active: orderBy == 'full_name' }"
                @click.prevent="refreshResults('full_name', 'asc')"
              >
                Alphabetical</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui column padded grid centered">
      <div class="row">
        <div v-if="false" class="three wide column">
          <div class="ui">
            <h4 class="ui center aligned icon header">
              <i class="circular filter icon"></i>
              Filter
            </h4>

            <table class="ui very basic table selectable red">
              <tbody class="ui">
                <tr @click.prevent="getResults(1, 'Saved')">
                  <td>
                    <i class="green circle icon"></i>

                    <span>
                      <strong>Saved</strong>
                    </span>
                  </td>
                  <td>#{{ allRecords.saved }}</td>
                  <td>
                    <i class="chevron right icon"></i>
                  </td>
                </tr>
                <tr @click.prevent="getResults(1, 'Archived')">
                  <td>
                    <i class="red circle icon"></i>
                    Archived
                  </td>
                  <td>
                    #
                    {{ allRecords.archived }}
                  </td>
                  <td>
                    <i class="chevron right icon"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h4 v-show="false" class="ui center aligned icon header">
            <i class="circular bolt icon"></i>
            Stats
          </h4>
        </div>
        <div class="twelve wide column">
          <div class="ui raised padded text segment">
            <div v-if="!showNewClientScreen">
              <form class="ui form" v-on:submit.prevent>
                <div class="field">
                  <sui-input
                    fluid
                    placeholder="Search ..."
                    v-model="searchText"
                    v-on:keyup="getResults(1)"
                  />
                </div>
              </form>
              <div v-if="message != ''" class="ui message">{{ message }}</div>
              <table class="ui compact table">
                <thead v-if="!loading">
                  <tr>
                    <th>Last Updated</th>

                    <th>Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody v-if="!loading">
                  <tr v-for="c in finalResults" :key="c.id">
                    <td style="width: 180px">
                      {{ new Date(c.updatedAsAt) | moment("Do MMM YYYY") }}
                      <small>{{
                        new Date(c.updatedAsAt) | moment("HH:mm")
                      }}</small>
                    </td>

                    <td>
                      <router-link :to="'/v2/client/' + c.id">{{
                        c.fullName
                      }}</router-link>
                    </td>
                    <td style="width: 180px">
                      <div
                        @click.prevent="deleteClient(c.id)"
                        class="ui tiny button"
                      >
                        Delete
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="loading">
                  <tr>
                    <td>
                      <div
                        class="hollow-dots-spinner"
                        v-if="loading"
                        :style="spinnerStyle"
                      >
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="ui grid">
                <div class="ui four wide column">
                  <div
                    class="ui primary large button"
                    v-if="!showNewClientScreen"
                    @click="showNewClientScreen = true"
                  >
                    Create New Client
                  </div>
                </div>
                <div class="ui twelve wide column">
                  <sui-menu
                    v-if="totalPages > 1"
                    style="float: right"
                    pagination
                  >
                    <a is="sui-menu-item" @click.prevent="getResults(1)" icon>
                      <sui-icon name="left chevron" />First Page
                    </a>
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 4 > 0 && currentPageNr - 4 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 4)"
                      >{{ currentPageNr - 4 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 3 > 0 && currentPageNr - 3 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 3)"
                      >{{ currentPageNr - 3 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 2 > 0 && currentPageNr - 2 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 2)"
                      >{{ currentPageNr - 2 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 1 > 0 && currentPageNr - 1 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 1)"
                      >{{ currentPageNr - 1 }}</a
                    >
                    <div is="sui-menu-item">
                      <strong>{{ currentPageNr }}</strong>
                    </div>

                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 1 > 0 && currentPageNr + 1 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 1)"
                      >{{ currentPageNr + 1 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 2 > 0 && currentPageNr + 2 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 2)"
                      >{{ currentPageNr + 2 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 3 > 0 && currentPageNr + 3 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 3)"
                      >{{ currentPageNr + 3 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 4 > 0 && currentPageNr + 4 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 4)"
                      >{{ currentPageNr + 4 }}</a
                    >

                    <a
                      is="sui-menu-item"
                      icon
                      @click.prevent="getResults(totalPages)"
                    >
                      <sui-icon name="right chevron" />Last Page
                    </a>
                  </sui-menu>
                </div>
              </div>
            </div>
            <div class="ui segment" v-show="showNewClientScreen">
              <div>
                <div class="ui attached message">
                  <div class="content">
                    <div class="header">New Client Details</div>
                  </div>
                </div>
                <div class="ui form attached fluid segment">
                  <div class="ui field">
                    <label>First Name</label>
                    <input v-model="clientFirstName" />
                  </div>
                  <div class="ui field">
                    <label>Last Name</label>
                    <input v-model="clientLastName" />
                  </div>
                  <div class="ui field">
                    <label>E-Mail</label>
                    <input v-model="email" />
                  </div>
	               
                  <div class="ui field">
                    <label>Date of Birth</label>
                    <input
                      type="date"
                      style="max-width: 200px"
                      v-model="birthday"
                    />
                    <br />
                    <small>Current age: {{ calculateAge(birthday) }}</small>
                  </div>
                </div>
                <div class="ui segment message">
                  <sui-button
                    v-show="false"
                    @click.prevent="editClick"
                    type="submit"
                    class="primary"
                    >Edit</sui-button
                  >
                  <div is="sui-button-group">
                    <sui-button
                      v-if="id != 0"
                      @click.prevent="showNewClientScreen = false"
                      >Cancel</sui-button
                    >
                    <sui-button-or v-if="id != 0" />
                    <sui-button
                      :disabled="!canSave"
                      positive
                      @click.prevent="saveClient"
                      >Create</sui-button
                    >
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getClientsV2, createClient, deleteClientV2 } from "@/gateway";
import { ClientView } from "@/dtos";
import moment from "moment";

export default {
  name: "ProposalList",
  props: {
    msg: String,
  },
  data() {
    return {
      // new client
      message: "",
      clientFirstName: "",
      clientLastName: "",
      currentAge: 55,
      email: "",
      birthday: null,
      showNewClientScreen: false,
      //
      results: [],
      filterStatus: "Saved",
      searchText: "",
      orderBy: "updated_as_at",
      order: "desc",
      loading: false,
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 5,
      totalPages: 1,
      allRecords: {
        saved: 0,

        archived: 0,
      },
    };
  },
  computed: {
    canSave() {
      if (
        this.clientFirstName != "" &&
        this.clientLastName != "" &&
        this.email != ""
      ) {
        return true;
      } else return false;
    },
    finalResults() {
      return this.results;
    },
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
  },
  methods: {
    async deleteClient(id) {
      this.message = "";
      const response = await deleteClientV2({ clientId: id });
      if (response) {
        this.$notify({
          group: "client",
          title: "Client deleted",
          position: "bottom right",
          type: "success",
        });

        this.message = "";
        this.getResults(1);
      }
    },
    calculateAge(arg) {
      return moment().diff(moment(arg, "YYYY-MM-DD"), "years");
    },
    formatDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYY-MM-DD").format(fmt);
      else return moment(arg, "YYYY-MM-DD").format("DD MMM YYYY HH:mm");
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg, "YYYYMMDD").format("DD MMM YYYY HH:mm");
    },
    async saveClient() {
      this.message = "";
      var response = await createClient({
        clientView: {
          id: 0,
          firstName: this.clientFirstName,
          lastName: this.clientLastName,
          primaryEmail: this.email,
          birthday: this.birthday,
        },
      });
      if (response) {
        if (response.result == true) {
          this.$router.push("/v2/client/" + response.id);
        } else {
          this.message =
            response.result == true ? "Success" : "Error creating client";
          this.showNewClientScreen = false;
          this.init();
        }
      }
    },
    async refreshResults(orderBy, ord) {
      this.pageNr = 1;
      this.orderBy = orderBy;
      this.order = ord;
      this.getResults(1);
    },
    async getResults(pageNr, filterStatus) {
      if (filterStatus) this.filterStatus = filterStatus;
      this.loading = true;
      //  await new Promise(r => setTimeout(r, 2000));
      var response = await getClientsV2({
        searchText: this.searchText,
        pageSize: this.currentPageSize,
        pageNr: pageNr,
        filterStatus: this.filterStatus,
        partnerId: this.$store.state.partnerId,
        orderBy: this.orderBy,
        order: this.order,
      });
      // console.log(response);
      this.totalRecords = response.totalRecords;
      this.totalPages = response.totalPages;
      this.currentPageNr = response.currentPageNr;
      this.results = response.result;
      this.loading = false;
    },
    async getResultCount(filterStatus) {
      var response = await getClientsV2({
        pageSize: 100000,
        pageNr: 1,
        filterStatus: filterStatus,
        partnerId: this.$store.state.partnerId,
      });
      //   console.log(response.totalRecords);

      if (filterStatus == "Saved")
        this.allRecords.saved = response.totalRecords;

      if (filterStatus == "Archived")
        this.allRecords.archived = response.totalRecords;
      //    console.log(this.allRecords);
    },
    async archivePlan(id) {
      //  console.log(" archiving plan " + id);
      /* const response = await updatePlanStatus({ id: id, status: "Archived" });
      console.log(response);
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async movePlanToSaved(id) {
      /* const response = await updatePlanStatus({ id: id, status: "Saved" });
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async init() {
      this.allRecords.saved = 0;
      this.allRecords.archived = 0;
      await this.getResults(1);
    },
  },
  async mounted() {
    this.init();
    this.birthday = moment()
      .add(-45, "years")
      .format("YYYY-MM-DD");
  },
};
</script>
